import { useMediaQuery } from '@chakra-ui/media-query';
import { Box, Button, Flex, Stack, Text, useColorMode } from "@chakra-ui/react";
import React from 'react';
import { updateForm } from '../../store/formReducer';
import { useStore } from "../../store/Store";
import Form from './form';

function CompoundForm() {
  const [isNotSmallerScreen] = useMediaQuery("(min-width:600px)");
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const [state, dispatch] = useStore();
  const {oneTime} = state;

  return (
    <Stack>
        <Flex direction={"column"} spacing="20px" p={isNotSmallerScreen ? "4" : "0"} alignSelf="flex-start" width="100%">
          <Box mt={isNotSmallerScreen ? "0" : "2"} align='flex-start' width="fit-content">
            <Text fontSize="xl" 
            fontWeight="bold" 
            alignSelf="flex-start"
            >Coumpound Interest Calculator</Text>
          </Box>
          <Box mt={isNotSmallerScreen ? "1" : "4"} align='flex-start'>
            <Box mt={isNotSmallerScreen ? "1" : "4"} mb={isNotSmallerScreen ? "2" : "4"} width="fit-content" align='flex-start'>
              <Text fontSize="md" fontWeight="normal" color={isDark ? "white.100" : "gray.700"} alignSelf="flex-start">Investment Type</Text>
            </Box>
            <Flex spacing="3px" alignSelf="flex-start">
              <Button colorScheme="teal" 
              onClick={() => dispatch(updateForm('oneTime', !oneTime))}
              variant={!oneTime ? "outline" : "ghost"}>
                Monthly
              </Button>
              <Button colorScheme="teal" 
              onClick={() => dispatch(updateForm('oneTime', !oneTime))}
              variant={oneTime ? "outline" : "ghost"}>
                One Time
              </Button>
            </Flex>
            <Box>
              <Form />
            </Box>
          </Box>
        </Flex>
    </Stack>
  )
}

export default CompoundForm